import axios from 'axios'

export default {
    uploadImage(images) {
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/images', images, config).then((response) => {
            return response
        })
    }
}
